import axios from "axios";
import { useMutation } from "react-query";
import { END_POINT } from "config/environment";
import { IContextTipPayload } from "../types";

export const updateContextTip = async (props: IContextTipPayload) => {
  const url = `${END_POINT.BASE_URL}/v1/administrator/context-tips/${props.id}`;
  const formData = new FormData();
  formData.append("title", props.title);
  formData.append("subtitle", props.subtitle ?? "");
  if (props.icon) formData.append("icon", props.icon);

  // POST route supports multipart icon uploads reliably.
  return axios.post(url, formData, {
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${props.token}`,
      "Content-Type": "multipart/form-data",
    },
  });
};

export const useUpdateContextTip = () => useMutation(updateContextTip);
